import { Grid2, Paper } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { CenteredLazyLoading } from "@/controls/LazyLoading";
import {
	getUndeclaredDelayRowClass,
	undeclaredDelayRowStyles,
} from "../../shared/hooks/useUndeclaredDelayRowStyle";
import { useTableData } from "../hooks/hooks";
import { DelayByShift } from "../models/DelayByShift";

type Props = {
	isLoading: boolean;
	rows: DelayByShift[];
	setGridApi: (params: GridApi) => void;
};

export const DelaysReportTable = ({ isLoading, rows, setGridApi }: Props) => {
	const { columns } = useTableData();

	return (
		<div onContextMenu={(e) => e.preventDefault()}>
			<Grid2
				container
				size={{ md: 12, xs: 12 }}
				sx={{
					height: "65vh",
					minHeight: "65vh",
				}}
				spacing={1}
				component={Paper}
				elevation={2}
			>
				<Grid2
					size={{ md: 12, xs: 12 }}
					height={"100%"}
					sx={undeclaredDelayRowStyles}
				>
					<AgGridReact<DelayByShift>
						loading={isLoading}
						rowData={rows}
						columnDefs={columns}
						animateRows
						singleClickEdit
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						onGridReady={(params) => setGridApi(params.api)}
						loadingOverlayComponent={CenteredLazyLoading}
						getRowClass={getUndeclaredDelayRowClass}
						gridOptions={{
							rowSelection: {
								mode: "singleRow",
								checkboxes: false,
								enableClickSelection: true,
							},
						}}
						suppressContextMenu
					/>
				</Grid2>
			</Grid2>
		</div>
	);
};
